<template>
    <div class="edit">
        <el-dialog title="活动" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="600px" @close="dialogFormVisible">
            <el-form ref="form" size="small" :model="form">

                <el-form-item label="活动标题" :label-width="formLabelWidth" prop="title" :rules="[{ required: true, message: ' ' }]">
                    <el-input v-model="form.title" placeholder="请输入活动名称"></el-input>
                </el-form-item>
                <el-form-item label="介绍类型" :label-width="formLabelWidth" prop="intro_name" :rules="[{ required: true, message: ' ' }]">
                    <el-input v-model="form.intro_name" placeholder="请输入介绍类型"></el-input>
                </el-form-item>
                <el-form-item label="荣誉类型" :label-width="formLabelWidth" prop="honor_name" :rules="[{ required: true, message: ' ' }]">
                    <el-input v-model="form.honor_name" placeholder="请输入荣誉类型"></el-input>
                </el-form-item>
                <el-form-item label="荣誉页面标题" :label-width="formLabelWidth" prop="honor_title" :rules="[{ required: true, message: ' ' }]">
                    <el-input v-model="form.honor_title" placeholder="请输入荣誉页面标题"></el-input>
                </el-form-item>
                <el-form-item label="规则说明" :label-width="formLabelWidth" prop="rule_intro">
                    <el-input type="textarea" :rows="4" v-model="form.rule_intro" placeholder="请输入规则说明" class="max-w460"></el-input>
                </el-form-item>
                <el-form-item label="村赞币倍数" :label-width="formLabelWidth" prop="coin_multiple">
                    <el-input v-model="form.coin_multiple" placeholder="请输入村赞币倍数"></el-input>
                </el-form-item>
                <el-form-item label="活动广告图片" :label-width="formLabelWidth" prop="image_id" :rules="[{ required: true, message: ' ' }]">
                    <div>
                        <el-button type="primary" @click="openUpload">上传图片</el-button>
                        <img v-img-url="form.image.file_path" class="mt10" width="120px;" alt="" />
                        <!--上传图片组件-->
                        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
                    </div>
                </el-form-item>
                <el-form-item label="活动时间" :label-width="formLabelWidth" prop="date_range" :rules="[{ required: true, message: ' ' }]">
                    <el-date-picker size="small" v-model="form.date_range" type="daterange" value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="报名截止日期" :label-width="formLabelWidth" prop="join_end_time" :rules="[{ required: true, message: ' ' }]">
                    <el-date-picker size="small" v-model="form.join_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="是否展示活动详情" :label-width="formLabelWidth" prop="is_show">
                    <el-switch v-model="form.is_show" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="活动状态" :label-width="formLabelWidth" prop="status">
                    <el-switch v-model="form.status" active-text="生效" inactive-text="未生效" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="排序" :label-width="formLabelWidth" prop="sort">
                    <el-input v-model="form.sort" placeholder="请输入排序"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible">取 消</el-button>
                <el-button type="primary" :disabled="submit_loading" @click="edit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    import Upload from "@/components/file/Upload";
    export default {
        props: [],
        components: {
            /*图片上传*/
            Upload: Upload,
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: "120px",
                /*是否显示*/
                dialogVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*是否上传图片*/
                isupload: false,
                form: {
                    title: "",
                    intro_name: "",
                    honor_name: "",
                    honor_title: "",
                    join_end_time: "",
                    status: "",
                    sort: "",
                    start_time: "",
                    end_time: "",
                    is_show: "",
                    image_id: "",
                    image: {},
                    date_range: [],
                },
            };
        },
        created() {
        },
        methods: {
            /*上传*/
            openUpload() {
                this.isupload = true;
            },

            /*获取图片*/
            returnImgsFunc(e) {
                let self = this;
                if (e != null) {
                    this.form.image_id = e[0].file_id;
                    this.form.image.file_path = e[0].file_path;
                }
                this.isupload = false;
            },
            showDialog (row) {
                this.dialogVisible = true;
                if (row !== undefined){
                    //赋值给表单
                    this.form = JSON.parse(JSON.stringify(row));
                }
            },
            /*修改*/
            edit() {
                let self = this;
                let params = this.form;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        self.submit_loading = true;
                        PlatformActivityApi.activity.edit(params, true)
                            .then((res) => {
                                self.submit_loading = false;
                                self.$message.success(res.msg);
                                self.dialogVisible = false;
                                self.$emit("closeDialog");
                            })
                            .catch((error) => {
                                self.submit_loading = false;
                            });
                    }
                });
            },

            /*关闭弹窗*/
            dialogFormVisible(e) {
                //重置表单的值
                this.resetFormFieldsData();
                this.$refs.form.resetFields()
                this.dialogVisible = false;
            },

            resetFormFieldsData() {
                let form = JSON.parse(JSON.stringify(this.form))
                Object.keys(form).forEach((k) => {
                    switch (typeof form[k]) {
                        case 'object':
                            if(Array.isArray(form[k])) {
                                form[k] = []
                            }else if(form[k]===null) {
                                form[k] = null
                            }else{
                                form[k] = {}
                            }
                            break
                        case 'bigint':
                            form[k] = 1
                            break
                        case 'number':
                            form[k] = 0
                            break
                        case 'string':
                            form[k] = ''
                            break
                        default:
                            break
                    }
                    // eslint-disable-next-line no-unreachable
                    if (this.formDefaultValues !== undefined && this.formDefaultValues[k] != undefined) {
                        form[k] = this.formDefaultValues[k]
                    }
                })
                this.form = form
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/platformactivity/activity/edit.vue